// extracted by mini-css-extract-plugin
module.exports = {"partners":"_85e05f","partnersInner":"_7b780a","partnersItem":"_51b53c"};